// extracted by mini-css-extract-plugin
module.exports = {"sections-navigation":"sections-navigation_sections-navigation__2YRiu","a__active":"sections-navigation_a__active__4h2ov","a__inactive":"sections-navigation_a__inactive__jrr7D"};